import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { richText } from '../../util/richText';
import Grid from '@material-ui/core/Grid';

import css from './ListingPage.module.css';

const SectionPracticalInfo = props => {
  const { publicData } = props;
  const parkingHeight = publicData.parkingHeight;
  const parkingLevel = publicData.parkingLevel;
  return parkingHeight && parkingLevel ? (
    <div className={css.sectionDescription}>
      <h2 className={css.descriptionTitle}>
        <FormattedMessage id="ListingPage.practicalInfoTitle" />
      </h2>
      <Grid container xs={12}>
        <Grid container item xs={12}>
          <p>🔝 {parkingHeight}</p>
        </Grid>

        <Grid container item xs={12}>
          <p>🔽 {parkingLevel}</p>
        </Grid>
      </Grid>
    </div>
  ) : null;
};

export default SectionPracticalInfo;
